/**
 * Convert a raw input value (string or number) to a finite Number.
 * Used to convert progressive form inputs ("1.", "1,50", "1.50")
 * to a usable Number at consumption boundaries (calc, validation, payload).
 * Returns 0 for invalid/empty input.
 */
export const toNumber = (v) => {
  if (v === '' || v == null) return 0;
  const n = parseFloat(String(v).replace(',', '.'));
  return Number.isFinite(n) ? n : 0;
};
